<template>
  <div class="my-4">

    <div class="">
      <h4>اشتراک های
        <span class="font-weight-bolder">{{ subscriptionUser() }}</span>
      </h4>
      <table class="table table-striped">
        <thead>
        <tr>
          <th scope="col">نام اشتراک</th>
          <th scope="col">اعتبار</th>
          <th scope="col">توضیحات</th>
          <th scope="col">عملیات</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(subscription,index) in subscriptions" :key="index">
          <th>
            {{ subscription.subscription.name }} - {{ subscription.subscriptionItem.name }}
            <span class="badge badge-danger" v-if="checkSubscriptionChargeStatus(subscription)">نیاز به تمدید</span>
          </th>
          <td dir="ltr">{{ chargeTranslator(subscription) }}</td>
          <td>{{ subscription.description }}</td>
          <td>
            <button class="btn btn-primary rounded-pill  mx-1" @click="getRelatedSubscriptions(subscription)"
                    v-b-modal="`subscription-modal-${subscription.id}`">تمدید اشتراک
            </button>
            <template v-if="isAdmin && false">
              <button class="btn btn-primary rounded-pill  mx-1">تغییر اشتراک</button>
              <button class="btn btn-primary rounded-pill  mx-1">شارژ اشتراک به صورت دستی</button>
            </template>

            <b-modal :id="`subscription-modal-${subscription.id}`" size="lg" hide-footer>

              <div class="text-right" dir="rtl">
                <div class="row">
                  <related-subscription-item v-for="(item,index) in relatedSubscriptions" :key="index"
                                             :subscriptionCharge="subscription" :item="item" class="col-12"/>

                </div>
              </div>
            </b-modal>
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <hr>

    <div class="my-5">
      <h4>فاکتورهای شما</h4>
      <subscription-user-orders/>
    </div>

  </div>
</template>

<script>

import {mapGetters} from "vuex";
import {dateConverter} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import RelatedSubscriptionItem from "@/plugin/components/dashboard/Subscription/RelatedSubscriptionItem.vue";
import SubscriptionUserOrders from "@/plugin/components/dashboard/Subscription/SubscriptionUserOrders.vue";
import fa from "@/plugin/support/locales/fa";

export default {
  name: "SubscriptionUsers",
  data() {
    return {
      page: 1,
      subscriptions: [],
      relatedSubscriptions: [],
    }
  },
  components: {SubscriptionUserOrders, RelatedSubscriptionItem},
  computed: {
    ...mapGetters({
      userId: "User/getUserId",
      isAdmin: "User/isAdmin"
    }),
  },
  methods: {
    async getUserSubscriptions(user) {
      let form = {
        page: this.page,
        user_id: user
      }
      let req = await this.$store.dispatch('Subscription/getUserSubscriptions', form)
      // this.subscriptions
      this.subscriptions = req.data.data.data
    },
    chargeTranslator(subscription) {
      // if subscription type was date we convert it
      // else we return actual value

      let subscriptionItem = subscription.subscriptionItem
      let subscriptionValue = subscription.value
      if (subscription.subscription.value_type === 'date') {
        return dateConverter(subscriptionValue, '/', true)
      }

      return subscriptionValue
    },
    async getRelatedSubscriptions(subscription) {
      this.relatedSubscriptions = []

      let form = {
        subscription_charge_id: subscription.id,
      }

      let req = await this.$store.dispatch('Subscription/getRelatedSubscriptions', form)

      this.relatedSubscriptions = req.data.data

    },
    checkNumberTypeSubscription(subscription) {
      return subscription.value < 100
    },
    checkDateTypeSubscription(subscription) {

      let givenDate = new Date(subscription.value);

      let now = new Date();

      let futureDate = new Date();
      futureDate.setDate(now.getDate() + 10);

      if (givenDate > futureDate) {
        return false
      }
      return true

    },
    checkSubscriptionChargeStatus(subscription) {
      let subscriptionType = subscription.subscription.value_type
      if (subscriptionType === 'number') {
        return this.checkNumberTypeSubscription(subscription)
      }
      if (subscriptionType === 'date') {
        return this.checkDateTypeSubscription(subscription)
      }
      return false
    },
    subscriptionUser() {
      let subscription = this.subscriptions
      if (subscription.length === 0) {
        return ''
      }

      let user = subscription[0].user;
      return `${user.name} ${user.last_name}`
    }
  },
  mounted() {
    let userId = this.userId;

    let routeName = this.$route.name
    if (routeName != 'UserSubscription') {
      userId = this.$route.params.user
    }

    this.getUserSubscriptions(userId)


  },
}
</script>

<style scoped>

</style>